import Vue from "vue";

export const Directives = () => {
    Vue.directive("numeric-only", {
        bind(el) {
            el.addEventListener("keypress", evt => {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (
                        charCode > 31 &&
                        (charCode < 48 || charCode > 57) &&
                        charCode !== 46
                        ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            });
        }
    });

    Vue.directive('alpha-only', {
        bind(el) {
            el.addEventListener("keypress", evt => {
                evt = evt ? evt : window.event;
                var char = evt.key;
                var re = /^[a-z0-9_]$/i;
                var isValid = re.test(char);
                if (isValid) {
                    return true;
                }
                evt.preventDefault();
            });
        }
    });
};
